import { useCallback } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { authState } from 'states/AuthState';
import { uiTheme } from 'states/UiState';
import { ThemeChoice, saveUserTheme } from 'helpers/themePreference';

/** The signed-in user's name, the key their theme is kept under. */
export const useThemeOwner = (): string | undefined => {
  const auth = useRecoilValue(authState);
  return auth.username || auth.emailId || undefined;
};

/** The current theme and a setter that also remembers the choice for the signed-in user. */
export function useThemePreference(): [ThemeChoice, (theme: ThemeChoice) => void] {
  const [theme, setTheme] = useRecoilState(uiTheme);
  const owner = useThemeOwner();
  const choose = useCallback(
    (next: ThemeChoice) => {
      setTheme(next);
      if (owner) saveUserTheme(owner, next);
    },
    [setTheme, owner]
  );
  return [theme, choose];
}
